import { PayrollDiscountCandidate } from "../../utils/is-payroll-discount";
import { trackOf } from "../../utils/decision-track";
import { CLASSIFICATION_BADGES } from "../../utils/constants";
import { ClassificationBadgeConfig } from "../../types";
import { CLASSIFICATION_BADGE_TEST_ID } from "../../utils/decision-test-ids";
import { StatusBadge } from "../shared/status-badge";

interface ClassificationBadgeProps {
  divergence: PayrollDiscountCandidate;
}

export function ClassificationBadge({
  divergence,
}: ClassificationBadgeProps): JSX.Element {
  const config: ClassificationBadgeConfig =
    CLASSIFICATION_BADGES[trackOf(divergence)];

  return (
    <div className="flex justify-center">
      <StatusBadge
        variant={config.variant}
        data-testid={CLASSIFICATION_BADGE_TEST_ID}
      >
        {config.label}
      </StatusBadge>
    </div>
  );
}
